import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import { PwaInstallPrompt } from "@/components/pwa/PwaInstallPrompt";
import "@/styles/global.css";
import "@/styles/mobileResponsive.css";
import "@/components/pwa/pwa.css";
import { startContinuousSignalBeep } from "@/lib/continuousSignalBeep";

/* eslint-disable react-refresh/only-export-components -- this entry module intentionally owns runtime bootstrap code. */

function PwaRuntime() {
  useEffect(() => {
    const handleServiceWorkerUpdate = (event: MessageEvent) => {
      if (event.data?.type !== "FI_RADAR_SW_UPDATED") return;
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener("message", handleServiceWorkerUpdate);
    return () => navigator.serviceWorker?.removeEventListener("message", handleServiceWorkerUpdate);
  }, []);

  useEffect(() => {
    const handlePushAlert = (event: MessageEvent) => {
      if (event.data?.type !== "FI_RADAR_SIGNAL_ALERT") return;
      try {
        if (localStorage.getItem("fi-radar-continuous-beep") === "true") {
          void startContinuousSignalBeep();
        }
      } catch {
        // Local-only alert preference.
      }
    };
    navigator.serviceWorker?.addEventListener("message", handlePushAlert);
    return () => navigator.serviceWorker?.removeEventListener("message", handlePushAlert);
  }, []);
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    if (!window.isSecureContext && window.location.hostname !== "localhost") return;

    const register = () => navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((error) => {
      console.error("FI Radar service worker registration failed", error);
    });

    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(register, { timeout: 3000 });
    } else {
      setTimeout(register, 1500);
    }
  }, []);

  return <PwaInstallPrompt />;
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
    <PwaRuntime />
  </StrictMode>,
);
